
const initialState = {
    username: null,
    password: null,
    ip: null,
    account: null,
    place: null,
    fullname: null,
    Address: null,
    tokenrb: null,
    mobile:null,
    LoginAnia:null,
    appData:{},
    creditPrice:false,
    systemId:null
}

function reducer(state = initialState, action) {


    switch (action.type) {
        case "LoginTrue": {
            return {
                username: action.username,
                password: action.password,
                ip: action.ip,
                account: action.account,
                place: action.place,
                fullname: action.fullname,
                Address: action.Address,
                mobile: action.mobile,
                LoginAnia: action.LoginAnia,
                appData:action.appData,
                creditPrice:action.creditPrice,
                systemId:action.systemId,
                tokenrb: action.tokenrb,

            }
            break;
        }
        case "noLogin": {
            return {
                appData:action.appData,
                systemId:action.systemId
            }
            break;
        }
        case "logout":  {
            localStorage.setItem("api_token",null);
            return {
                username: null,
                password: null,
                ip: null,
                account: null,
                place: null,
                fullname: null,
                Address: null,
                mobile:null,
                LoginAnia:null,
                appData:action.appData,
                creditPrice:false,
                systemId:action.systemId,
                tokenrb: null,
            }
        }
        default: {
            return initialState;
        }
    }
}
export default reducer;